module.exports = __webpack_public_path__ + "static/media/image1.768998c6.jpg";